import React from "react";
import * as d3 from "d3";
import {
    parseTemplate,
    convertTemplateForDisplay,
    accountingDataParseSign,
    getNodeValueByTitle,
    numberWithSpaces,
    inheritColorAndValueFromParents,
    calculatePercentage,
    accountingDataPostUpdateValue,
    parseAccountingData,
    parseAccountingDataColorSumPosts,
    parseAccountingDataFinancialPostsColors,
} from "../../utils";
import $ from "jquery";


// definitions

let i = 0, duration = 750, root;
const interval = {min: 5, max: 75};
const OPACITY_COLOR = "#fff";

// declarations

let treeData;
let svg;
let treemap;

function collapse(d) {
    if (d.children && d.depth > 1) {
        d._children = d.children;
        d._children.forEach(collapse);
        d.children = null;
    } else if (d.children) {
        d.children.forEach(collapse);
    }
}

class BaseAccountTreeD3 extends React.Component {

    constructor(props) {

        super(props);

        let accountingData;

        if(this.props.accountingData) {
            accountingData = this.props.accountingData.sort(function(a, b) {
                return a.bsNumber - b.bsNumber;
            });
        }

        let accountingDataParsed = accountingDataParseSign(accountingData);

        let parsedTable = parseAccountingData(accountingDataParsed);
        let parsedTablePre = parseTemplate(parsedTable.children);

        console.log(parsedTablePre);

        let displayTable = convertTemplateForDisplay(parsedTablePre);
        let coloredTable = inheritColorAndValueFromParents(displayTable);
        let coloredTableParsed = parseAccountingDataColorSumPosts(coloredTable);
        parseAccountingDataFinancialPostsColors(coloredTableParsed);


        coloredTableParsed[0].showValue = false;
        coloredTableParsed[1].showValue = false;

        treeData = {
            title: "",
            id: 0,
            children: coloredTableParsed,
            value: 0,
            color: "#ddd",
            showValue: false,
        };

        treeData = accountingDataPostUpdateValue(
            treeData,
            "Resultaträkning",
            Math.abs(getNodeValueByTitle(treeData.children, "Intäkter")) +
            Math.abs(getNodeValueByTitle(treeData.children, "Kostnader")) +
            Math.abs(getNodeValueByTitle(treeData.children, "Finansiella poster"))
        );

        treeData = accountingDataPostUpdateValue(
            treeData,
            "Balansräkning",
            2 * getNodeValueByTitle(treeData.children, "Tillgångar")
        );

        treeData.value = getNodeValueByTitle(treeData.children, "Resultaträkning") + getNodeValueByTitle(treeData.children, "Balansräkning")

        this.renderSVG = this.renderSVG.bind(this);
        this.renderNodeMap = this.renderNodeMap.bind(this);
        this.update = this.update.bind(this);

        this.state = {
            sum: treeData.value,
            displayTable: coloredTableParsed
        };

    }

    componentDidMount() {
        this.renderSVG();
    }

    renderSVG() {

        let graph = "#base-account-tree";
        let height = 1000;
        let width = 0;
        let minWidth = 1400;

        if ($(graph).innerWidth() < minWidth) {
            width = minWidth;
        } else {
            width = $(graph).innerWidth();
        }

        let margin = {left: "100"};

        treemap = d3.tree().size([height, width]);

        if (this.props.inData != null && this.props.inData.children.length > 0) {
            treeData = JSON.parse(JSON.stringify(this.props.inData));
        }

        root = d3.hierarchy(treeData, function (d) {
            return d.children;
        });
        root.x0 = height / 2;
        root.y0 = 0;

        svg = d3
            .select("#base-account-tree-svg")
            .attr("width", width)
            .attr("height", height)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + 0 + ")");

        svg.append('svg:defs');

        this.renderNodeMap();
    }

    renderNodeMap() {
        root.children.forEach(collapse);
        this.update(root);
    }

    update(source) {

        let lineHeight = 7;
        let self = this;

        // Assigns the x and y position for the nodes
        let treeData = treemap(root);

        // Compute the new tree layout.
        let nodes = treeData.descendants(),
            links = treeData.descendants().slice(1);

        // Normalize for fixed-depth.
        nodes.forEach(function (d) {
            d.y = d.depth * 180;
        });

        // ****************** Nodes section ***************************

        // Update the nodes...
        let node = svg.selectAll("g.node").data(nodes, function (d) {
            return d.id || (d.id = ++i);
        });

        // Enter any new modes at the parent's previous position.
        let nodeEnter = node
            .enter()
            .append("g")
            .attr("class", "node")
            .attr("transform", function (d) {
                return "translate(" + source.y0 + "," + source.x0 + ")";
            })
            .on("click", click);

        // Add Circle for the nodes
        nodeEnter
            .append("circle")
            .attr("class", "node")
            .attr("r", 1e-6)
            .style("fill", function (d) {
                return d._children ? "#444" : "#fff";
            });
        // Add labels for the nodes
        nodeEnter
            .append("text")
            .style("font-size", "12px")
            .style("font-family", "sans-serif")
            .attr("dy", ".35em")
            .attr("x", function (d) {
                return d.children || d._children ?
                    -self.calculateTextPosition(d.data.value) :
                    self.calculateTextPosition(d.data.value);
            })
            .attr("y", function (d) {
                if (d.data.hasOwnProperty("showValue") && d.data.showValue === false) {
                    return 0;
                } else {
                    return -lineHeight;
                }
            })
            .attr("text-anchor", function (d) {
                return d.children || d._children ? "end" : "start";
            })
            .text(function (d) {
                if(d.data.bsNumber) {
                    return d.data.title + " [" + d.data.bsNumber + "]";
                } else if (d.data.interval) {
                    return d.data.title + " [" + d.data.interval[0] + "-" + d.data.interval[1] + "]";
                } else {
                    return d.data.title;
                }

            });
        nodeEnter
            .append("text")
            .style("font-size", "12px")
            .style("font-family", "sans-serif")
            .attr("dy", ".35em")
            .attr("x", function (d) {
                return d.children || d._children ?
                    -self.calculateTextPosition(d.data.value) :
                    self.calculateTextPosition(d.data.value);
            })
            .attr("y", function (d) {
                if (d.data.hasOwnProperty("showValue") && d.data.showValue === false) {
                    return 0;
                } else {
                    return lineHeight;
                }
            })
            .attr("text-anchor", function (d) {
                return d.children || d._children ? "end" : "start";
            })
            .text(function (d) {
                if (d.data.hasOwnProperty("showValue") && d.data.showValue === false) {
                    return "";
                } else {
                    let valueString = numberWithSpaces(d.data.value) + " kr";
                    if (d.data.hasOwnProperty("parentValue")) {
                        let differencePercentage = calculatePercentage(d.data.value, d.data.parentValue, 0);
                        if (differencePercentage === 0) {
                            return valueString + " (0%)";
                        } else {
                            return valueString + " (" + numberWithSpaces(differencePercentage) + " %)";
                        }
                    } else {
                        return valueString;
                    }
                }
            });

        // UPDATE
        let nodeUpdate = nodeEnter.merge(node);

        // Transition to the proper position for the node
        nodeUpdate
            .transition()
            .duration(duration)
            .attr("transform", function (d) {
                return "translate(" + d.y + "," + d.x + ")";
            });

        // Update the node attributes and style
        nodeUpdate
            .select("circle.node")
            .attr("r", function (d) {
                return self.calculateRadius(d.data.value);
            })
            .style("fill", function (d) {
                if (d.data.id === 0 || d.data.id === 1 || d.data.id === 3) {
                    return "url(#svg-icon-" + d.data.id + ")"
                }
                return self.isNotProportional(d.data.value) && d.data.color ? OPACITY_COLOR : d.data.color;
            })
            .style("stroke", function (d) {
                console.log(d.data);
                if (d.data.id === 0 || d.data.id === 1 || d.data.id === 3) {
                    return d.data.color;
                }
                return self.isNotProportional(d.data.value) && d.data.color ? d.data.color : d.data.color;
            })
            .style("stroke-width", function (d) {
                return "2px";
            })
            .attr("cursor", "pointer");

        // Remove any exiting nodes
        let nodeExit = node
            .exit()
            .transition()
            .duration(duration)
            .attr("transform", function (d) {
                return "translate(" + source.y + "," + source.x + ")";
            })
            .remove();

        // On exit reduce the node circles size to 0
        nodeExit.select("circle").attr("r", 1e-6);

        // On exit reduce the opacity of text labels
        nodeExit.style("fill-opacity", 1e-6);

        // ****************** links section ***************************

        // Update the links...
        let link = svg.selectAll("path.link").data(links, function (d) {
            return d.id;
        });

        // Enter any new links at the parent's previous position.
        let linkEnter = link
            .enter()
            .insert("path", "g")
            .attr("class", "link")
            .style("fill", "none")
            .style("stroke", "#ccc")
            .style("stroke-width", "2px")
            .attr("d", function (d) {
                let o = {x: source.x0, y: source.y0};
                return diagonal(o, o);
            });

        // UPDATE
        let linkUpdate = linkEnter.merge(link);

        // Transition back to the parent element position
        linkUpdate
            .transition()
            .duration(duration)
            .attr("d", function (d) {
                return diagonal(d, d.parent);
            });

        // Remove any exiting links
        link
            .exit()
            .transition()
            .duration(duration)
            .attr("d", function (d) {
                let o = {x: source.x, y: source.y};
                return diagonal(o, o);
            })
            .remove();

        // Store the old positions for transition.
        nodes.forEach(function (d) {
            d.x0 = d.x;
            d.y0 = d.y;
        });

        // Creates a curved (diagonal) path from parent to the child nodes

        let up = this.update;

        // Toggle children on click.
        function click(d) {
            if (d.children) {
                d._children = d.children;
                d.children = null;
            } else {
                d.children = d._children;
                d._children = null;
            }
            up(d);
        }

        function diagonal(s, d) {
            return (
                "M" + s.y +
                "," + s.x +
                "C" + (s.y + s.y) / 2 +
                "," + s.x +
                " " + (s.y + d.y) / 2 +
                "," + d.x +
                " " + d.y +
                "," + d.x
            );
        }
    }

    calculateScaleSum(table) {
        return getNodeValueByTitle(table, "Bokslut");
    };

    calculateRadius(value) {
        let r = interval.max * this.calculateRadiusUncapped(value);
        if (r < interval.min) {
            r = interval.min;
        }
        return r;
    }

    calculateRadiusUncapped(value) {
        let rTotal = Math.sqrt(Math.abs(this.state.sum) / Math.PI);
        let r = Math.sqrt(Math.abs(value) / Math.PI);
        return r / rTotal || 0;
    }

    calculateTextPosition(value) {
        return this.calculateRadius(value) + 5;
    }

    isNotProportional(value) {
        let r = interval.max * this.calculateRadiusUncapped(value);
        return (r < interval.min);
    }

    render() {

        let radius = interval.max;
        let width = radius * 2;
        let height = radius * 2;
        let x = 25 + radius;
        let y = 25 + radius;

        return (
            <div id="base-account-tree">
                <svg id="base-account-tree-svg" width="0" height="0" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="svg-icon-0" width={width} height={height} x={x} y={y}
                                 patternUnits="userSpaceOnUse">
                            <svg width={width + "px"} height={height + "px"} viewBox={"0 0 " + width + " " + height}>
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="logo-base-account-tree">
                                        <rect id="Rectangle" fill="#FFFFFF" x="0" y="0" width={width}
                                              height={height}></rect>
                                        <path
                                            d="M50.8275862,60.8836364 L50.8275862,86.8963636 L38.4827586,86.8963636 C38.4827586,85.3763636 42.8965517,87.3454545 43.5862069,77.7418182 L43.5862069,60.8836364 L50.8275862,60.8836364 Z"
                                            id="Path"
                                            fill="#38B1E5"></path>
                                        <path
                                            d="M63.9655172,86.8963636 L51.6206897,86.8963636 L51.6206897,75.98 C51.6206897,75.98 51.6551724,75.98 51.6551724,75.98 L51.6551724,60.8490909 L58.8965517,60.8490909 L58.8965517,78.0872727 C59.6551724,87.2763636 64,85.4109091 63.9655172,86.8963636 Z"
                                            id="Path"
                                            fill="#f35656"></path>
                                        <path
                                            d="M46.1034483,13.2454545 C46,13.2454545 45.8965517,13.2454545 45.7586207,13.2454545 C44.8965517,13.2454545 44.0689655,13.5563636 43.4482759,14.04 C43.2068966,14.2472727 42.9655172,14.4545454 42.7586207,14.7309091 C41.7241379,14.8 40.8275862,15.2836364 40.2068966,16.0090909 C40.0344828,15.9745454 39.8275862,15.94 39.6551724,15.94 C38.137931,15.94 36.9310345,17.1490909 36.9310345,18.6690909 L36.9310345,18.7036364 C36.6206897,18.7727273 36.3103448,18.8763636 36.0689655,19.0490909 C35.5862069,18.8418182 35.0689655,18.7381818 34.5172414,18.7381818 C33.0689655,18.7381818 31.7931035,19.4981818 31.0689655,20.6727273 C30.9310345,20.6381818 30.8275862,20.6381818 30.6896552,20.6381818 C29.5862069,20.6381818 28.6896552,21.5363636 28.6896552,22.6418182 L28.6896552,22.6763636 C27.5517241,23.2290909 26.7586207,24.4036364 26.7586207,25.7509091 C26.7586207,26.8909091 27.3103448,27.8927273 28.1724138,28.5145455 C27,28.8254545 26.1724138,29.8963636 26.1724138,31.14 C26.1724138,32.1072727 26.6896552,32.9709091 27.4482759,33.4545455 C27.4827586,33.9727273 27.6896552,34.4563636 28.0344828,34.8018182 C28.0344828,34.8018182 28.0344828,34.8018182 28.0344828,34.8018182 C27.9310345,34.8709091 27.8275862,34.94 27.7586207,35.0090909 C27.7241379,35.0436364 27.6551724,35.1127273 27.6206897,35.1472727 C27.5862069,35.1818182 27.5517241,35.2163636 27.5172414,35.2854545 C27.5172414,35.2854545 27.5172414,35.2854545 27.5172414,35.2854545 C27.2758621,35.5963636 27.137931,35.9763636 27.137931,36.3909091 C27.137931,36.8745455 27.3103448,37.3236364 27.6551724,37.6345455 C27.6896552,37.6690909 27.7586207,37.7381818 27.7931035,37.7727273 C27.8275862,37.8072727 27.862069,37.8418182 27.8965517,37.8763636 C27.9310345,37.9109091 27.9655172,37.9109091 28,37.9454545 C28.1034483,38.0145455 28.2413793,38.0836364 28.3793103,38.1181818 C28.5517241,38.1872727 28.7241379,38.1872727 28.9310345,38.1872727 C28.9655172,38.1872727 29.0344828,38.1872727 29.0689655,38.1872727 C29.1724138,38.7745455 29.6551724,39.2236364 30.2068966,39.3618182 L30.2068966,39.3963636 C30.2068966,50.8309091 39.4827586,60.1236364 50.8965517,60.1236364 L50.8965517,18.6690909 L50.9310345,18.6690909 L50.9310345,18.3581818 L50.9310345,12.2090909 L50.9310345,11.2763636 C48.9655172,11.2763636 47.3103448,12.0363636 46.1034483,13.2454545 Z"
                                            id="Path"
                                            fill="#71B74C"></path>
                                        <path
                                            d="M75.7586207,25.7163636 C75.7586207,23.8163636 74.2413793,22.2963636 72.3448276,22.2963636 C72.2413793,22.2963636 72.1034483,22.2963636 72,22.3309091 C71.7931034,20.2927273 70.0689655,18.7381818 68,18.7381818 C67.4482759,18.7381818 66.9310345,18.8418182 66.4482759,19.0490909 C66.1724138,18.8763636 65.8275862,18.7381818 65.4827586,18.6690909 C65.5517241,18.4618182 65.5862069,18.22 65.5862069,17.9781818 C65.5862069,16.4581818 64.3793103,15.2490909 62.862069,15.2490909 C62.6551724,15.2490909 62.4827586,15.2836364 62.3103448,15.3181818 C61.6206897,14.5236364 60.5862069,14.0054546 59.4482759,14.0054546 C58.7931034,14.0054546 58.1724138,14.1781818 57.6206897,14.4890909 C57.5862069,14.3854546 57.5862069,14.3163636 57.5517241,14.2127273 C57.3448276,13.4181818 56.862069,12.7272727 56.2413793,12.2436364 C55.6206897,11.7254545 54.7931034,11.4490909 53.9310345,11.4490909 C53.7586207,11.4490909 53.5862069,11.4490909 53.4137931,11.4836364 C52.862069,11.3454545 52.2758621,11.2418182 51.6896552,11.2418182 L51.6896552,24.3690909 L51.6551724,24.3690909 L51.6551724,60.0890909 C61.5862069,60.0890909 69.862069,53.0763636 71.862069,43.7490909 C71.862069,43.7490909 71.862069,43.7145455 71.862069,43.7145455 C71.9310345,43.4727273 71.9655172,43.2309091 72,42.9890909 C72,42.9890909 72,42.9890909 72,42.9890909 C72,42.9890909 72,42.9545455 72,42.9545455 C72.2068966,41.78 72.3103448,40.6054545 72.3103448,39.3618182 C72.3103448,38.1872727 72.2068966,37.0127273 72.0344828,35.8727273 C72.4482759,35.4581818 72.6551724,34.9054545 72.6551724,34.2836364 C72.6551724,33.9727273 72.5862069,33.6963636 72.4827586,33.4545455 C73.5172414,33.3854545 74.3448276,32.5218182 74.3448276,31.4509091 C74.3448276,30.7945455 74.0344828,30.2072727 73.5172414,29.8272727 C73.7241379,29.5509091 73.8275862,29.1709091 73.862069,28.7909091 C74.9655172,28.2381818 75.7586207,27.0636364 75.7586207,25.7163636 Z"
                                            id="Path"
                                            fill="#fada0c"></path>
                                    </g>
                                </g>
                            </svg>
                        </pattern>
                        <pattern id="svg-icon-3" width={width} height={height} x={0} y={0}
                                 patternUnits="userSpaceOnUse">
                            <svg width={width + "px"} height={height + "px"} viewBox={"0 0 " + width + " " + height}>
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="Wrapper">
                                        <rect id="right" fill="#71B74C" x={radius} y="0" width={radius} height={height}></rect>
                                        <rect id="left" fill="#fada0c" x="0" y="0" width={radius} height={height}></rect>
                                    </g>
                                </g>
                            </svg>
                        </pattern>
                        <pattern id="svg-icon-1" width={width} height={height} x={0} y={0}
                                 patternUnits="userSpaceOnUse">
                            <svg width={width + "px"} height={height + "px"} viewBox={"0 0 " + width + " " + height}>
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="Wrapper">
                                        <rect id="right" fill="#38B1E5" x={radius} y="0" width={radius} height={height}></rect>
                                        <rect id="left" fill="#f35656" x="0" y="0" width={radius} height={height}></rect>
                                    </g>
                                </g>
                            </svg>
                        </pattern>
                    </defs>
                </svg>
            </div>
        );
    }

}

export default BaseAccountTreeD3;
